import { makeStyles } from "@material-ui/core/styles";
import { FONTS } from "../../emotion-theme";

export const useErrorPageStyles = makeStyles(() => ({
  text: {
    fontFamily: FONTS.primary,
    fontSize: "1.4rem",
    fontWeight: "bold",
  },
  title: {
    fontFamily: FONTS.primary,
    fontSize: "10rem",
    lineHeight: "10rem",
    margin: "30px 0 0",
  },
  subTitle: {
    fontFamily: FONTS.primary,
    fontSize: "2.5rem",
    margin: "0",
  },
}));
